import { BadgeCheck, Star } from "lucide-react";
import Reveal from "@/components/Reveal";
import { REVIEWS } from "@/data/content";

const Stars = () => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 text-[#C86D51] fill-current" />
    ))}
  </div>
);

export default function Reviews() {
  const [big, ...rest] = REVIEWS;
  return (
    <section id="reviews" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-14 sm:mb-16 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#C86D51] mb-4">Early Tasters</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2C221E]">
              From our test kitchen<br />to <em className="italic text-[#6A2C3E]">their</em> tables
            </h2>
          </div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#6E5E57]">
            5.0 ★ · 200+ happy bakes
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6" data-testid="reviews-grid">
          <Reveal className="md:col-span-2 md:row-span-2">
            <figure className="h-full rounded-[2rem] bg-[#2C221E] text-[#FAF7F2] p-8 sm:p-12 flex flex-col justify-between gap-8">
              <div>
                <Stars />
                <blockquote className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-snug mt-6 tracking-tight">
                  “{big.quote}”
                </blockquote>
              </div>
              <figcaption className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-[#F8C8DC] text-[#6A2C3E] flex items-center justify-center font-serif font-semibold">
                  {big.name[0]}
                </span>
                <div>
                  <p className="text-sm font-medium flex items-center gap-1.5">
                    {big.name} <BadgeCheck className="w-4 h-4 text-[#D1E8E2]" />
                  </p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF7F2]/50">{big.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>

          {rest.map((r, i) => (
            <Reveal key={r.name} delay={0.08 * (i + 1)} className={i === rest.length - 1 && rest.length % 3 === 0 ? "md:col-span-2" : ""}>
              <figure className="h-full rounded-[2rem] bg-[#FAF7F2] border border-[#2C221E]/10 p-7 flex flex-col justify-between gap-5 hover:border-[#2C221E]/25 hover:-translate-y-1 transition-all duration-300">
                <div>
                  <Stars />
                  <blockquote className="text-[#2C221E]/85 leading-relaxed mt-4 text-sm sm:text-base">“{r.quote}”</blockquote>
                </div>
                <figcaption className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-[#D1E8E2] text-[#2A524A] flex items-center justify-center font-serif font-semibold text-sm">
                    {r.name[0]}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-[#2C221E] flex items-center gap-1.5">
                      {r.name} <BadgeCheck className="w-3.5 h-3.5 text-[#2A524A]" />
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E5E57]">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
